import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DaysheetcloseConfirmationMessageDialogData {
  title?: string;
  message?: string;
  /** Overrides the default body text (e.g. update wording when daysheet is PENDING). */
  confirmMessage?: string;
  /** Overrides the confirm button label (e.g. "Daysheet Update" when PENDING). */
  confirmLabel?: string;
}

@Component({
  selector: 'app-daysheetclose-confirmation-message-dialog',
  templateUrl: './daysheetclose-confirmation-message-dialog.component.html',
  styleUrls: ['./daysheetclose-confirmation-message-dialog.component.scss'],
})
export class DaysheetcloseConfirmationMessageDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DaysheetcloseConfirmationMessageDialogData,
    private dialogRef: MatDialogRef<DaysheetcloseConfirmationMessageDialogComponent>,
  ) {}

  daysheetClose(): void {
    this.dialogRef.close('daysheetClose');
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
